import type { IconShortcutProps } from '@/components_deprecated'
import { IconShortcut, ShortcutsWrapper } from '@/components_deprecated'
import { useTranslate } from '@ur-solutions/react-hooks'
import styled from 'styled-components'

const Wrapper = styled.section`
  max-width: 100%;
`

interface DashboardFormsProps {
  links: IconShortcutProps[]
}

export const DashboardForms: React.FC<DashboardFormsProps> = ({ links }) => {
  const translations = useTranslate({
    forms: 'common.forms',
  })
  return (
    <Wrapper>
      <h2>{translations.forms}</h2>
      <ShortcutsWrapper>
        {links.map(link => (
          <IconShortcut key={link.text} {...link} />
        ))}
      </ShortcutsWrapper>
    </Wrapper>
  )
}
